
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/enviu",
      function () {
        return require("private-next-pages/corporatiu/enviu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/enviu"])
      });
    }
  